// Import React components
import React, {useState, useEffect} from 'react';
import './App.css'
import {BrowserRouter, Route, Redirect} from 'react-router-dom'

// Import counters
import {YMInitializer} from 'react-yandex-metrika'
import YMInit from 'react-yandex-metrika/lib/init'
import ReactGA from 'react-ga';

// Import my components and modules
import {GOOGLE_CLIENT_ID} from "./Data/Constants";
import {Context} from './Data/Context/Context'
import NavBar from "./Components/NavBar";
import CatalogContent, {observeGID} from "./Components/CatalogContent"
import ContactsModal from "./Modals/ContactsModal";
import LoginModal from "./Modals/LoginModal";
import SchemeModal from "./Modals/SchemeModal";
import BasketContent from "./Components/BasketContent";
import AdminPage from "./Components/AdminPage";
import {AlertState} from "./Data/Context/Alert/AlertState";
import {decodeJWT} from "./Data/OAuth";
import {GoogleOAuthProvider} from '@react-oauth/google';

YMInit([1223162], {webvisor: true}, '2')

// Main function
function App() {
    const [Basket, setBasket] = useState([])
    const [Summary, setSummary] = useState(0)
    const [contactsMState, setContactsMState] = useState(false)
    const [loginMState, setLoginMState] = useState(false)
    const [schemeMState, setSchemeMState] = useState('');
    const [UserCreds, setUserCreds] = useState({user: '', price: 0, email: '', phone: '', isAdmin: false})
    const [redirector, setRedirector] = useState('')
    // const [width, setWidth] = useState(window.innerWidth);
    //
    // const onWindowResize = () => {
    //     // console.log('Resized, new width: ', window.innerWidth)
    //     setWidth(window.innerWidth);
    // }
    //
    // useEffect(() => {
    //     window.addEventListener('resize', onWindowResize)
    // }, [])

    useEffect(() => {
        const trackingId = "UA-26878841-2"; // Replace with your Google Analytics tracking ID
        ReactGA.initialize(trackingId);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])

    // Redirector component to redirect just by setRedirector URL setting up
    function Redirector(props) {
        if (redirector.length > 0) {
            setRedirector('')
            return <Redirect to={redirector}/>
        } else {
            return <></>
        }
    }

    // Show or hide Contacts modal window
    function setContactsModalState(newVal) {
        setContactsMState(newVal)
    }

    // get Contacts modal window state
    function getContactsModalState() {
        return contactsMState
    }

    // Show or hide Login modal window
    function setLoginModalState(newVal) {
        setLoginMState(newVal)
    }

    // get Login modal window state
    function getLoginModalState() {
        return loginMState
    }

    // Show or hide Scheme modal window
    function setSchemeModalState(newVal) {
        setSchemeMState(newVal);
    }

    // get Scheme modal window state
    function getSchemeModalState() {
        return schemeMState;
    }

    // Restore session from server on mount
    useEffect(() => {
        fetch('/api/me')
            .then(r => r.json())
            .then(data => {
                if (data.loggedIn) {
                    setUserCreds({user: data.email, price: data.priceNo, email: data.email, phone: data.phone || '', isAdmin: data.isAdmin})
                }
            })
            .catch(() => {})
    }, [])

    // If Basket is changed, recount Summary
    useEffect(() => {
        setSummary(getBasketSummary())
// eslint-disable-next-line
    }, [Basket, UserCreds]) // Added UserCreds to recount Summary when user logged in

    // onChangeUser handler for TextInput (backward compat, no-op)
    function onChangeUser(text) {}

    // onChangePass handler for TextInput (backward compat, no-op)
    function onChangePass(text) {}

    // Login button is clicked
    async function onLoginClick(email, pass) {
        try {
            const r = await fetch('/api/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password: pass})
            })
            if (!r.ok) return false
            const data = await r.json()
            setUserCreds({user: data.email, price: data.priceNo, email: data.email, phone: data.phone || '', isAdmin: data.isAdmin})
            observeGID.next(observeGID.value)
            return true
        } catch (e) {
            console.error('Login error:', e)
            return false
        }
    }

    // Registration button is clicked
    async function onRegisterClick(email, passPlain, phone, recaptchaToken) {
        try {
            const r = await fetch('/api/register', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password: passPlain, phone, recaptchaToken})
            })
            if (r.status === 409) return 'exists'
            if (!r.ok) return false
            const data = await r.json()
            setUserCreds({user: data.email, price: data.priceNo, email: data.email, phone: data.phone || '', isAdmin: data.isAdmin})
            observeGID.next(observeGID.value)
            return true
        } catch (e) {
            console.error('Registration error:', e)
            return false
        }
    }

    // Logout
    async function onLogoutClick() {
        try {
            await fetch('/api/logout', {method: 'POST'})
        } catch {}
        setUserCreds({user: '', price: 0, email: '', phone: '', isAdmin: false})
        observeGID.next(observeGID.value)
    }

    // Google OAuth login
    async function onGoogleLogin(credentialResponse) {
        try {
            const payload = decodeJWT(credentialResponse.credential);
            if (!payload || !payload.email) {
                console.error('Google OAuth: не удалось декодировать JWT');
                return;
            }

            const googlePhone = payload.phone_number || payload.phone || '';
            const r = await fetch('/api/google-login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email: payload.email, googleId: payload.sub, phone: googlePhone})
            })
            if (!r.ok) throw new Error('HTTP ' + r.status)
            const data = await r.json()
            setUserCreds({user: data.email, price: data.priceNo, email: data.email, phone: data.phone || '', isAdmin: data.isAdmin})
            observeGID.next(observeGID.value)
        } catch (e) {
            console.error('Google OAuth error:', e);
        }
    }

    // Get user cridentials
    function getUserCreds() {
        return UserCreds
    }

    // Get user's price number
    function getUserPriceNo() {
        return UserCreds.price
    }

// Delete Basket item by key
    function delBasketItem(key) {
        setBasket(Basket.filter(bItem => {
            return bItem.key !== key
        }))
    }

    // Add Basket item
    function addBasketItem(bItem) {
        if (Basket.findIndex(Item => Item.id === bItem.id) === -1) {
            bItem.key = Date.now()
            bItem.count = 1
            setBasket(prev => [...prev, bItem])
        }
    }

    // Set count of item in basket
    function changeCount(key, cnt) {
        setBasket(Basket.map(bItem => {
            if (bItem.key === key) {
                bItem.count = cnt
            }
            return bItem
        }))
    }

    // Get basket items count
    function getBasketCount() {
        let Cnt = 0
        Basket.forEach(Item => {
            Cnt += Item.count
        })
        return Cnt
    }

    // Calculate basket sum
    function getBasketSummary() {
        let Sum = 0
        Basket.forEach(Item => {
            Sum += Item['price' + getUserPriceNo()] * Item.count
        })
        return Sum
    }

    // function called in children components to get basket pointer
    function getBasket() {
        return Basket
    }

    // function called in children components to get summary pointer
    function getSummary() {
        return Summary
    }

    // Clear the basket
    function clearBasket() {
        setBasket([])
    }

    // Route to /detail.pl is for search support of an old site

    // returning JSX
    return (
        <Context.Provider value={{
            setContactsModalState, getContactsModalState,
            setLoginModalState, getLoginModalState, setRedirector,
            onChangeUser, onChangePass, onLoginClick, onRegisterClick,
            onLogoutClick, onGoogleLogin,
            getUserPriceNo, getBasketCount, addBasketItem, getBasket,
            changeCount, getSummary, delBasketItem, clearBasket,
            getUserCreds, setSchemeModalState, getSchemeModalState
        }}>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <BrowserRouter>
                    <Redirector/>
                    <YMInitializer accounts={[1223162]}/>
                    <AlertState>
                        <div className="app-wrapper">
                            <header className="App-Header">
                                <NavBar/>
                            </header>
                            <div className="App-Content">
                                <Route exact path='/' component={CatalogContent}/>
                                <Route path='/detail.pl' component={CatalogContent}/>
                                <Route path='/basket' component={BasketContent}/>
                                <Route path='/admin' component={AdminPage}/>
                                <ContactsModal/>
                                <LoginModal/>
                                <SchemeModal/>
                            </div>
                            <div className="App-Footer">
                                Разработка сайта: компания <a href="http://www.serverflot.ru" target="_blank"
                                                               rel="noopener noreferrer">"Серверный
                                флот"</a>
                            </div>
                        </div>
                    </AlertState>
                </BrowserRouter>
            </GoogleOAuthProvider>
        </Context.Provider>
    );
}

// Export App function
export default App;
